import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    invitationId: Number
  }

  open() {
    window.currentDeclineInvitationId = this.invitationIdValue

    const modal = document.getElementById("client-decline-modal")
    if (modal) {
      modal.classList.remove("hidden")
    }
  }

  close() {
    this.element.classList.add("hidden")

    const reasonInput = document.querySelector("textarea[name='decline_reason']")
    if (reasonInput) {
      reasonInput.value = ""
    }
  }

  submit() {
    const reasonInput = document.querySelector("textarea[name='decline_reason']")
    const reason = reasonInput ? reasonInput.value : ""
    const invitationId = window.currentDeclineInvitationId

    if (!invitationId) {
      console.error("No invitation ID found")
      return
    }

    const form = document.createElement("form")
    form.method = "POST"
    form.action = `/clients/invites/${invitationId}/decline`

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    if (csrfToken) {
      const tokenInput = document.createElement("input")
      tokenInput.type = "hidden"
      tokenInput.name = "authenticity_token"
      tokenInput.value = csrfToken
      form.appendChild(tokenInput)
    }

    const reasonField = document.createElement("input")
    reasonField.type = "hidden"
    reasonField.name = "decline_reason"
    reasonField.value = reason
    form.appendChild(reasonField)

    document.body.appendChild(form)
    form.submit()
  }
}
